export default {
  paymentChannels(state) {
    return state.paymentChannels
  },
}
